module.exports = __webpack_public_path__ + "img/cai-chatbot-background.svg";